<template>
  <div>
    <!-- St1ickers -->
    <br />
    <h2 class="section-title">{{ $t("stickersTitleSection") }}</h2>
    <div class="container-alb">
      <div class="section-table filter-mobile">
        <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
          <tr>
            <td valign="middle">
              <h3>{{ $t("stickersInfo") }}</h3>
            </td>
          </tr>
          <tr>
            <td valign="middle" colspan="2">
              <div class="d-inline-block" v-for="(mediumSticker, index) in stickers[0].medium" :key="index">
                <div class="sticker-wrapper">
                  <img class="sticker-image" :src="
                    require('@/assets/images/affiliate-stickers/' +
                      mediumSticker.file_name)
                  " />
                </div>
              </div>
            </td>
          </tr>
        </table>
        <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
          <tr>
            <td valign="middle">
                  <h3 class="m-0">{{ $t("bigStickersLabel")    }}
                  <input type="number" name="quantity" class="quantity-input" v-model="bigStickerAmount" />
                  {{ $t("quantityStickers") }}</h3>
            </td>
          </tr>
          <tr>
            <td valign="middle">
                <h3 class="m-0">{{ $t("smallStickersLabel") }}
                <input type="number" name="quantity" class="quantity-input" v-model="smallStickerAmount" />
                {{ $t("quantityStickers") }}</h3>
            </td>
          </tr>
        </table>
        <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
          <tr>
            <td valign="middle">
              <form @submit.prevent="
                {
                  return false;
                }
              ">
                <strong>{{ $t("deliveryAddressStickers") }}</strong>
                <multiselect v-model="selectedWorkingPointAddress" :options="workingPointAddress"
                  :placeholder="$t('selectLabel')" select-label="" selected-label="" deselect-label=""
                  openDirection="bottom" track-by="codcom" :custom-label="customLabel" :loading="isLoading"
                  @input="subsidiarySelected()">
                </multiselect>
              </form>
            </td>
            <td valign="middle" align="right">
              <a class="button-orange" @click="sendStrickers()">{{
                $t("textButtonForm")
              }}</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="section-table filter-mobile">
        <table cellpadding="10" cellspacing="0" width="95%" class="hover-table" align="center">
          <tr>
            <td valign="middle">
              <!-- <h3 class="mt-0">{{ $t("digitalStickersLabel") }}</h3> -->
              <h3>{{ $t("digitalStickersText") }} <a :href="
                    require('@/assets/images/affiliate-stickers/' +
                    stickers[0].electronic[0].file_name)
                  " class="cursor-pointer" >aici.</a></h3> 
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <b>
          <p v-if="this.sentStickersError" v-html="$t('stickersError_' + this.sentStickersError.code)"></p>
          <p v-else-if="this.sentStickers">{{ $t("stickersSentSuccess") }}</p>
        </b>
      </div>
    </div>

    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')"></p>
      </div>
    </div>

  </div>
</template>

<script>
import Cookies from "js-cookie";
import stickers from "@/assets/json/stickers.js";
import httpServiceAffiliate from "@/http/http-affiliate.js";
import Multiselect from "vue-multiselect";
import httpServiceUser from "@/http/http-user.js";
import {
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";

export default {
  props: {
    affiliate: Object,
    msg: String
  },
  components: {
    "b-form-checkbox": BFormCheckbox,
    "b-form-checkbox-group": BFormCheckboxGroup,
    Multiselect
  },
  data() {
    return {
      stickers: stickers,
      selectedDelivery: "0",
      selectedStickers: [],
      error: null,
      subsidiaries: [],
      sentStickers: false,
      sentStickersError: null,
      otherStickerText: "",
      workingPointAddress: [],
      selectedWorkingPointAddress: "",
      filters: {
        subsidiary: this.affiliate.company_id
      },
      isLoading: false,
      smallSticker: false,
      smallStickerAmount: 0,
      bigStickerAmount: 0,
    };
  },
  methods: {
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    subsidiarySelected() {
      if (
        this.selectedWorkingPointAddress === "" ||
        this.selectedWorkingPointAddress === null
      ) {
        this.filters.subsidiary = this.affiliate.company_id;
      } else {
        this.filters.subsidiary = this.selectedWorkingPointAddress.codcom;
      }
    },
    isSelectedSubsidiary(subsidiary) {
      return subsidiary === this.filters.subsidiary;
    },
    getAddressPoints(env, brand) {
      this.environment = env;
      this.isLoading = true;
      var params =
        "?type=affiliate" +
        "&brand=" +
        brand +
        "&environment=" +
        this.environment +
        "&per_page=10000&page=1";

      if (this.affiliate.user_config && this.affiliate.user_config.config) {
        if (this.affiliate.user_config.config.invoice_group) {
          params += "&invoice_group=1";
        }
      }

      httpServiceUser.userService
        .getAddressPoints(
          this.affiliate.company_id,
          params,
          Cookies.get("token")
        )
        .then(response => {
          if (response.status == 200) {
            this.subsidiaries = response.data;
            this.isLoading = false;
            this.subsidiaries.forEach(x => {
              this.workingPointAddress.push({
                codcom: x.codcom,
                address: x.address.street_name + ", " + x.address.locality
              });
            });
          } else if (response.status == 400 || response.status == 403) {
            return null;
          } else {
            return null;
          }
        })
        .catch(error => {
          return null;
        });
    },
    getStickersForSubmit() {
      var returnStickers = [];
      if (this.smallStickerAmount > 0)
        returnStickers.push({
          id: "autocolant_casa_marcat_2023",
          description: "Autocolant casa marcat 2023",
          amount: this.smallStickerAmount
        });
      if (this.smallStickerAmount > 0)
        returnStickers.push({
          id: "autocolant_vitrina_2023",
          description: "Autocolant vitrina 2023",
          amount: this.bigStickerAmount
        });
      return returnStickers;
    },
    sendStrickers() {
      if (this.smallStickerAmount === 0 && this.bigStickerAmount === 0) {
        return;
      }
      var formData = {
        affiliate_id: this.filters.subsidiary,
        details: this.getStickersForSubmit()
      };
      this.sentStickersError = null;
      this.sentStickers = false;

      this.showModalPopup("modal_popup_loading", true);

      httpServiceAffiliate.affiliateService
        .sendStickers(this.affiliate.company_id, formData, Cookies.get("token"))
        .then(response => {
          if (response.status == 200) {
            this.sentStickers = true;
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else if (response.status == 400 || response.status == 403) {
            this.sentStickersError = { code: "500" };
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.sentStickersError = { code: "500" };
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch(error => {
          this.sentStickersError = { code: "500" };
          this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    sendOtherStickers() {
      if (this.otherStickerText.length === 0) {
        return;
      }
      var formData = {
        affiliate_id: this.filters.subsidiary,
        details: [
          {
            amount: this.otherStickerText,
            description: "Autocolant Other",
            id: "other"
          }
        ]
      };
      this.sentStickersError = null;
      this.sentStickers = false;

      this.showModalPopup("modal_popup_loading", true);

      httpServiceAffiliate.affiliateService
        .sendStickers(this.affiliate.company_id, formData, Cookies.get("token"))
        .then(response => {
          if (response.status == 200) {
            this.sentStickers = true;
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else if (response.status == 400 || response.status == 403) {
            this.sentStickersError = { code: "500" };
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.sentStickersError = { code: "500" };
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          }
        })
        .catch(error => {
          this.sentStickersError = { code: "500" };
          this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    customLabel({ codcom, address }) {
      return `${codcom} – ${address}`;
    }
  },
  mounted() {
    this.getAddressPoints("both", this.affiliate.products[0].brand);
  }
};
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.sticker-wrapper {
  background-color: #f1f1f1;
  padding: 10px;
  display: inline-block;
  width: auto;
  margin: 10px;
}

.sticker-image {
  display: block;
  margin-bottom: 10px;
  max-width: 400px;
}

.quantity-checkbox {
  display: inline-block;
  width: auto;
}

.quantity-input,
input[type="number"].quantity-input {
  display: inline-block;
  width: 30px;
  padding: 0 3px;
  height: auto;
  margin: 0 10px 0 15px;
}

.sticker-wrapper .custom-control-input:checked~.custom-control-label::before {
  background-color: #4e5b59;
}
</style>
